import { AppRoutes } from '@/constants/routes';

export const BREAKPOINTS = {
  mobile: 768,
  tablet: 1024,
  desktop: 1280,
};

export const publicPaths = [AppRoutes.AUTH, AppRoutes.CONSENT, AppRoutes.EVENT];
